export default {
    "Alabama": {
        text_x: (xCoord) => xCoord,
        text_y: (yCoord) => yCoord - 16
    },
    "California": {
        text_x: (xCoord) => xCoord - 15,
        text_y: (yCoord) => yCoord 
    },
    "Florida": {
        text_x: (xCoord) => xCoord + 50,
        text_y: (yCoord) => yCoord 
    },
    "Georgia": {
        text_x: (xCoord) => xCoord,
        text_y: (yCoord) => yCoord - 10
    },
    "Idaho": {
        text_x: (xCoord) => xCoord,
        text_y: (yCoord) => yCoord + 25
    },
    "Illinois": {
        text_x: (xCoord) => xCoord,
        text_y: (yCoord) => yCoord - 15
    },
    "Kentucky": {
        text_x: (xCoord) => xCoord,
        text_y: (yCoord) => yCoord - 10
    },
    "Minnesota": {
        text_x: (xCoord) => xCoord - 15,
        text_y: (yCoord) => yCoord
    },
    "Montana": {
        text_x: (xCoord) => xCoord,
        text_y: (yCoord) => yCoord - 15
    },
    "Nevada": {
        text_x: (xCoord) => xCoord,
        text_y: (yCoord) => yCoord - 25
    },
    "North Carolina": {
        text_x: (xCoord) => xCoord,
        text_y: (yCoord) => yCoord - 15
    },
    "Oklahoma": {
        text_x: (xCoord) => xCoord + 15,
        text_y: (yCoord) => yCoord - 15 
    },
    "South Carolina": {
        text_x: (xCoord) => xCoord,
        text_y: (yCoord) => yCoord - 15
    },
    "South Dakota": {
        text_x: (xCoord) => xCoord,
        text_y: (yCoord) => yCoord - 15
    }
}